import{__require as r}from"../is_date/index.js";var e,n;function t(){if(n)return e;n=1;var t=r();return e=function(r){if(t(r))return!isNaN(r);throw new TypeError(toString.call(r)+" is not an instance of Date")}}export{t as __require};
//# sourceMappingURL=index.js.map
